class p {
  constructor(p_l){
    this.p_l = p_l;
  }

  get(name){
    return this.p_l[name];
  }
}

const Params_aux = () => {
    let aux = window.location.search.replace('?','');
    let params = {};
    aux.split('&').forEach(p=>{
        let a = p.split('=');
        params[a[0]] = a[1]?a[1]:'';
    });
    return new p(params);
  };

const Params = Params_aux();

export default Params;